// Event-type → SLDS utility icon + color mapping.
import { colors } from './tokens';

export const timelineIcon = {
  gift:      { name: 'moneybag',    color: colors.timeline.gift },
  email:     { name: 'email',       color: colors.timeline.email },
  call:      { name: 'call',        color: colors.timeline.call },
  task:      { name: 'task',        color: colors.timeline.task },
  note:      { name: 'note',        color: colors.timeline.note },
  event:     { name: 'event',       color: colors.timeline.event },
  web:       { name: 'world',       color: colors.timeline.web },
  volunteer: { name: 'favorite',    color: colors.timeline.volunteer },
  system:    { name: 'settings',    color: colors.timeline.system },
  pledge:    { name: 'contract',    color: colors.timeline.gift },
  recurring: { name: 'sync',        color: colors.timeline.gift },
};

export const quickActionIcon = {
  'log-gift': { name: 'moneybag', label: 'Log Gift' },
  'email':    { name: 'email',    label: 'Email' },
  'call':     { name: 'call',     label: 'Call' },
  'task':     { name: 'task',     label: 'Task' },
  'note':     { name: 'note',     label: 'Note' },
  'pledge':   { name: 'contract', label: 'Pledge' },
};

export const statusChipConfig = {
  major:     { label: 'Major Donor', ...colors.status.major },
  monthly:   { label: 'Monthly',     ...colors.status.monthly },
  board:     { label: 'Board',       ...colors.status.board },
  volunteer: { label: 'Volunteer',   ...colors.status.volunteer },
  alumni:    { label: 'Alumni',      ...colors.status.alumni },
  lapsed:    { label: 'Lapsed',      ...colors.status.lapsed },
  deceased:  { label: 'Deceased',    ...colors.status.deceased },
};

export const movesConfig = [
  { id: 'id',      label: 'Identification', color: colors.moves.id },
  { id: 'qual',    label: 'Qualification',  color: colors.moves.qual },
  { id: 'cult',    label: 'Cultivation',    color: colors.moves.cult },
  { id: 'solicit', label: 'Solicitation',   color: colors.moves.solicit },
  { id: 'stw',     label: 'Stewardship',    color: colors.moves.stw },
];
